module.exports = __webpack_public_path__ + "media/images/post/icon_sns_pn-ce3cd4deb22c08a2b5ad76e165a0d9fb.png";